exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label[data-v-1b2f0488]{font-size:8px}.label-medium[data-v-1b2f0488]{font-size:9px}.label-large[data-v-1b2f0488]{font-size:10px}.value[data-v-1b2f0488]{font-size:18px;line-height:18px;font-weight:bolder}.text-black[data-v-1b2f0488]{color:#000}", ""]);

// exports
